import React, { useEffect, useState, useCallback } from 'react';
import ListArquives from './list.jsx';
import { Spinner,  Pagination,
  Table,
  Button,
  PaginationItem,
  PaginationLink, } from 'reactstrap';
import api from '../../services/client/api';
import cookie from '../../services/cookie/index';
import {  deleteCookies } from '../../utils/functions';
import { useHistory, useLocation } from 'react-router-dom';
import { faMicroscope, faSort } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import NoExams from '../../components/NoExams/';

export default function Arquives() {

useEffect(() => {
    document.title = "Painel - HMSJ";
  }, []);

  const [groupedReports, setGroupedReports] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState('');
const qtdPerPage = 5; // meses por página
const [page, setPage] = useState(1);
const [order, setOrder] = useState("desc"); 
// desc = mais recente primeiro
// asc = mais antigo primeiro

const orderedReports = [...groupedReports].sort((a, b) => {
  if (a.Year === b.Year) {
    return order === "desc"
      ? b.Month - a.Month
      : a.Month - b.Month;
  }

  return order === "desc"
    ? b.Year - a.Year
    : a.Year - b.Year;
});

const qtdPages = Math.ceil(orderedReports.length / qtdPerPage);

// Pega somente os meses da página atual
const paginatedReports = orderedReports.slice(
  qtdPerPage * (page - 1),
  qtdPerPage * page
);

  const history = useHistory();
  const location = useLocation();

  const token = cookie().get('tokenDoc');
  const username = cookie().get('username');

  const getReports = useCallback(async () => {
    try {
      const response = await api().user().getAllArquives(token);

      if (response.status === 401) {
        await deleteCookies();
        return history.replace({ pathname: '/doctor' });
      }
      console.log(response.output)
      if (response.status === 200) {
        setGroupedReports(response.output); // 👈 já vem agrupado
        setIsLoading(false);
      } else if (response.status === 404) {
        setErrorMessage('error');
        setIsLoading(false);
      }
    } catch (error) {
      console.error('Erro ao obter arquivos:', error);
      setErrorMessage('Erro ao carregar arquivos.');
      setIsLoading(false);
    }
  }, [history, token]);

  useEffect(() => {
    if (username) {
      getReports();
    }

    if (location.state?.successMessage) {
      alert(location.state.successMessage);
      history.replace({ pathname: location.pathname, state: {} });
    }
  }, [username, location, history, getReports]);


const PaginationComponent = () => {
  let elements = [];

  for (let i = page - 3; i < page; i++) {
    if (i > 0) {
      elements.push(
        <PaginationItem key={i} active={i === page}>
          <PaginationLink onClick={() => setPage(i)}>{i}</PaginationLink>
        </PaginationItem>
      );
    }
  }

  for (let i = page - 1; i < qtdPages && i < page + 3; i++) {
    const thisPage = i + 1;
    elements.push(
      <PaginationItem key={thisPage} active={thisPage === page}>
        <PaginationLink onClick={() => setPage(thisPage)}>{thisPage}</PaginationLink>
      </PaginationItem>
    );
  }

  return (
    <Pagination>
      <PaginationItem>
        <PaginationLink first onClick={() => setPage(1)} disabled={page === 1} />
      </PaginationItem>

      <PaginationItem disabled={page === 1}>
        <PaginationLink previous onClick={() => setPage(page - 1)} />
      </PaginationItem>

      {elements}

      <PaginationItem disabled={page === qtdPages}>
        <PaginationLink next onClick={() => setPage(page + 1)} />
      </PaginationItem>

      <PaginationItem disabled={page === qtdPages}>
        <PaginationLink last onClick={() => setPage(qtdPages)} />
      </PaginationItem>
    </Pagination>
  );
};


  return (
    <div>
      {!errorMessage && (
        <h1>
          <FontAwesomeIcon icon={faMicroscope} /> Arquivos por Mês
        </h1>
      )}

      {isLoading ? (
        <div>
          <Spinner color="primary" /> Carregando...
        </div>
      ) : errorMessage ? (
        <NoExams cpf={username} />
      ) : (
        <>
          {groupedReports.length === 0 && <NoExams cpf={username} />}

          <>
  {paginatedReports.length === 0 && <NoExams cpf={username} />}
<div style={{ display: "flex", justifyContent: "flex-start", marginBottom: 10 }}>
  <Button
    color="secondary"
    onClick={() =>
      setOrder(order === "desc" ? "asc" : "desc")
    }
  >
    Ordenar: {order === "desc" ? "Mais recente" : "Mais antigo"}
      <FontAwesomeIcon icon={faSort}  style={{ marginLeft: 5 }} />
  </Button>
</div>

  <Table striped bordered responsive style={{ marginTop: '10px' }}>
  <thead>
    <tr>
      <th style={{ textAlign: 'center' }}>Mês</th>
      <th style={{ textAlign: 'center' }}>Quantidade de Registros</th>
      <th style={{ textAlign: 'center' }}>Download</th>
    </tr>
  </thead>

  <tbody>
    {paginatedReports.map((group, index) => (
      <ListArquives
        key={index}
        reports={group.Items}
        month={group.Month}
        year={group.Year}
        token={token}
      />
    ))}
  </tbody>
</Table>



  {qtdPages > 1 && <PaginationComponent />}
</>

        </>
      )}
    </div>
  );
}
